export default __webpack_public_path__ + "images/slide_5.jpeg?f6639c1415b96f0276fc5b1df40726cc";